import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-othertransaction',
  templateUrl: './othertransaction.component.html',
  styleUrls: ['./othertransaction.component.css']
})
export class OthertransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/othertransaction/othertransaction.component.ts